import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "../locales/en.json";
import hi from "../locales/hi.json";
import mr from "../locales/mr.json";

const resources = {
  en: { translation: en },
  hi: { translation: hi },
  mr: { translation: mr },
};

const supportedLngs = ["en", "hi", "mr"];
const fallbackLng = "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs,
    fallbackLng,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
